


import { useState } from 'react';
import { Container, Grid, Avatar, Drawer, Tooltip, IconButton } from '@mui/material';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { GoBack } from '../common/GoBack/GoBack';
import { CustomTitle } from '../common/CustomTitle/CustomTitle';
import { LogScreenRealTime } from './LogScreenRealTime/LogScreenRealTime';
import { LogScreenHistory } from './LogScreenHistory/LogScreenHistory';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

export const LogScreen = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const handleToggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    return (
        <>
            <Container
                maxWidth={false}
                sx={{
                    padding: 2,
                    transition: 'margin 0.3s',
                    marginRight: drawerOpen ? '40vw' : 0
                }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <GoBack />
                            <CustomTitle
                                title="Logs Históricos"
                                icon={<Avatar><TextSnippetIcon /></Avatar>}
                                advanced={true}
                            />
                        </div>
                        <Tooltip title={drawerOpen ? 'Ocultar logs' : 'Ver logs en tiempo real'}>
                            <IconButton onClick={handleToggleDrawer} >
                                {drawerOpen ? <KeyboardDoubleArrowRightIcon/> : <KeyboardDoubleArrowLeftIcon />}
                            </IconButton>
                        </Tooltip>

                    </Grid>

                    <Grid item xs={12}>
                        <LogScreenHistory />
                    </Grid>
                </Grid>
            </Container>

            <Drawer
                variant="persistent"
                anchor="right"
                open={drawerOpen}
                sx={{ zIndex: 1300 }}
                PaperProps={{
                    sx: { width: '40vw', padding: 2 },
                }}
            >
                <LogScreenRealTime onClose={handleToggleDrawer} />
            </Drawer>
        </>
    );
};
